module.exports = __webpack_public_path__ + "static/media/folderIcon.e842b04a.svg";